module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/openweather-weathercodes/10n-6a1e50d9ab2bd155f81920caab221f15.svg";